import avatarModule from '../avatarModule';

function avatarBase(avatarUrlConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: avatarUrlConstants.templates.avatarBase
  };
}

avatarModule.directive('avatarBase', avatarBase);

export default avatarBase;
